import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import { PrimaryButtonOutlined, PrimaryButton } from "@components/Button";
import Dialog from "@components/Dialog";
import Div from "@components/Div";
import { H3, H5 } from "@components/Heading";
import { Text, TextMediumWeight } from "@components/Text";

const ConfirmConsentDialog = ({ orderDetails, onClose, onConfirm }) => {
  const { messages, formatMessage } = useIntl();

  return (
    <Dialog
      visible
      draggable={false}
      textAlign="center"
      m={[3, 3, "auto"]}
      width={[1, 1, "500px"]}
      onHide={onClose}
    >
      <Div display="flex" flexDirection="column" gridGap="20px">
        <Div
          display="flex"
          flexDirection="column"
          alignItems="center"
          gridGap="15px"
        >
          <H3 textAlign="center">{messages.label_confirm_consent}</H3>

          <Text textAlign="center">{messages.description_confirm_consent}</Text>

          {[
            {
              titleKey: "title_person",
              value: orderDetails.candidateName,
            },
            { titleKey: "label_order_number", value: orderDetails.orderId },
          ].map(({ titleKey, value }, index) => (
            <React.Fragment key={`${index}-${titleKey}`}>
              <TextMediumWeight>
                {titleKey !== ""
                  ? formatMessage({ id: titleKey }) + ": " + value
                  : value}
              </TextMediumWeight>
            </React.Fragment>
          ))}

          <Div width={1} display="flex" flexDirection="column" gridGap="5px">
            <Div
              width={1}
              display="flex"
              flexDirection="column"
              gridGap="10px"
              p="10px"
              borderRadius="10px"
              backgroundColor="var(--blue-lightest)"
            >
              <Div
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width={1}
                gridGap="30px"
              >
                <Text>{messages.label_services}</Text>

                <Text>{messages.label_case_id}</Text>
              </Div>
            </Div>

            <Div
              width={1}
              display="flex"
              flexDirection="column"
              gridGap="10px"
              p="10px"
              borderRadius="10px"
              backgroundColor="var(--blue-lightest)"
            >
              {orderDetails.services.map(service => (
                <Div
                  key={service.name}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width={1}
                  gridGap="30px"
                >
                  <H5>{service.name}</H5>

                  <H5>{service.caseId}</H5>
                </Div>
              ))}
            </Div>
          </Div>
        </Div>

        <Div
          width={1}
          display="flex"
          flexDirection={["column", "column", "row"]}
          justifyContent="center"
          gridGap="30px"
        >
          <PrimaryButtonOutlined
            label={messages.label_cancel}
            onClick={onClose}
          />

          <PrimaryButton
            label={messages.label_confirm_consent}
            onClick={onConfirm}
          />
        </Div>
      </Div>
    </Dialog>
  );
};

ConfirmConsentDialog.propTypes = {
  orderDetails: PropTypes.shape({
    orderId: PropTypes.string,
    candidateName: PropTypes.string,
    services: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        caseId: PropTypes.string,
      })
    ),
  }),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ConfirmConsentDialog;
